export default __webpack_public_path__ + "static/media/3.3c797659.jpg";